module.exports = __webpack_public_path__ + "static/logo_cambridge-1b117e829492200dd0b672f8ef85edaf.png";